module.exports = __webpack_public_path__ + "assets/media/ring-in.47573dbf.mp3";